var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReset2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C9CB6D62-0F87-4CC8-84FC-F9F7E1CD9BDE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.290222 0 0 0 0 0.290175 0 0 0 0 0.290237 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-2.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7.0-Tasks",
    transform: "translate(-610.000000, -1499.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "reset",
    transform: "translate(610.000000, 1497.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0000096,8.01381693 C16.0056823,11.6814886 13.4976365,14.8781009 9.92689585,15.7542495 C6.35615523,16.6303981 2.64748137,14.9591754 0.94653252,11.7074694 C-0.754416334,8.45576339 -0.00712313194,4.46571118 2.75606464,2.04576281 C5.51925241,-0.37418557 9.58271574,-0.597304312 12.5955325,1.50549223 L12.4980087,1.22252159 C12.3413224,0.746354841 12.6013151,0.233655153 13.0787186,0.0773747841 C13.5561222,-0.0789055845 14.0701535,0.180413563 14.2268398,0.656580311 L15.1134199,3.30943005 C15.2026061,3.57920098 15.1564294,3.87528227 14.9892987,4.10528497 C14.8148999,4.35022993 14.5277451,4.49010504 14.2268398,4.47668394 L11.5670996,4.47668394 C11.0774549,4.47668394 10.6805195,4.08077684 10.6805195,3.59240069 C10.687093,3.20837979 10.9414478,2.87250076 11.3099913,2.76117444 C8.91120108,1.26581106 5.80211152,1.57758382 3.74977655,3.51929638 C1.69744158,5.46100894 1.22124422,8.54127343 2.59183167,11.0094187 C3.96241911,13.477564 6.83293774,14.7089783 9.57192566,14.003786 C12.3109136,13.2985938 14.225217,10.8352577 14.2268398,8.01381693 C14.2268398,7.52544077 14.6237753,7.12953368 15.1134199,7.12953368 C15.6030646,7.12953368 16.0000096,7.52544077 16.0000096,8.01381693 L16.0000096,8.01381693 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReset2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/reset2.6ae97c6cac530b488a5fde1d4377dcb4.svg";